import React, {useEffect, useState, useRef} from "react"; 
import {NavLink} from "react-router-dom"; 
import {getBillingPlanOverview, removeCreditCard} from "../../../services/BilingService"; 
import {toast} from "react-toastify"; 
import Utils from "../../../utils"; 
import CancelRenewPlan from "./CancelRenewPlan"; 
import PaymentCardEdit from "./PaymentCardEdit"; 
import EnableRenewPlan from "./EnableRenewPlan"; 
import "./Billing.css"; 

function BillingOverview() { 

    const [companyData, setCompanyData] = useState({}); 
    const [loading, setLoading] = useState(false); 

    const removeCreditCardRef = useRef(null); 

    useEffect(function () { 
        setLoading(true); 

        getBillingPlanOverview({}) 
            .then(response => { 
                setCompanyData(response.data.data); 
                setLoading(false); 
            }) 
            .catch(err => { 
                setLoading(false); 
                toast.error(Utils.getErrorMessage(err)); 
            }); 

    }, []); 

    const handleDeleteCard = (e) => { 
        e.preventDefault(); 

        setLoading(true); 
        removeCreditCard({}) 
            .then(response => { 
                removeCreditCardRef?.current.click(); 
                toast.success(response.data.message); 

                let data = {...companyData}; 
                data.card_type = ''; 
                setCompanyData(data); 
                setLoading(false); 
            }) 
            .catch(err => { 
                setLoading(false); 
                toast.error(Utils.getErrorMessage(err)); 
            }); 
    }; 

    return ( 
        <> 
            {loading && <div className="page-loading"> 
                <img src="/images/loader.gif" alt="loader"/> 
            </div>} 

            <div className="billing-container"> 
                
                <h2 className="billing-page-title">Billing Overview</h2> 
                
                <div className="row">
                    {/* Left Column - Billing Profile */}
                    <div className="col-xl-7">
                        <div className="billing-card"> 
                            <div className="billing-card-header"> 
                                <h5 className="billing-card-title">Billing Profile</h5> 
                            </div> 
                            <div className="billing-card-body"> 
                                
                                <div className="row mb-3">
                                    <div className="col-sm-4 billing-label">Billing Name:</div>
                                    <div className="col-sm-8 billing-value">{companyData.full_name}</div>
                                </div>
                                
                                <div className="row mb-3">
                                    <div className="col-sm-4 billing-label">Company:</div>
                                    <div className="col-sm-8 billing-value">{companyData.company_name}</div>
                                </div>

                                <hr className="text-muted opacity-25 my-4" />
                                
                                <div className="row mb-3 align-items-center">
                                    <div className="col-sm-4 billing-label">Plan Type:</div>
                                    <div className="col-sm-8">
                                        <span className="billing-value fs-5">{companyData.plan_type}</span>
                                        {companyData.new_plan && ( 
                                            <span className="badge bg-light text-primary ms-2">{companyData.new_plan}</span> 
                                        )} 
                                        <NavLink to={"/billing/pricing"} className="billing-btn-primary ms-3" 
                                                 data-toggle="tooltip" data-placement="right" title="Update Plan">
                                            Update
                                        </NavLink> 
                                    </div>
                                </div>

                                {companyData.billing_frequency && ( 
                                    <div className="row mb-3">
                                        <div className="col-sm-4 billing-label">Billing Frequency:</div>
                                        <div className="col-sm-8 billing-value">{companyData.billing_frequency}</div>
                                    </div>
                                )} 

                                {companyData.next_billing_date && ( 
                                    <div className="row mb-3">
                                        <div className="col-sm-4 billing-label">Next Billing Date:</div>
                                        <div className="col-sm-8 billing-value">{companyData.next_billing_date}</div>
                                    </div>
                                )} 

                                {companyData.billing_status > 0 && ( 
                                    <div className="row mb-3 align-items-center">
                                        <div className="col-sm-4 billing-label">Billing Status:</div>
                                        <div className="col-sm-8">
                                            <span className={`badge ${parseInt(companyData.billing_status) === 1 ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} px-3 py-2 rounded-pill`}>
                                                {parseInt(companyData.billing_status) === 1 ? `Paid` : `Not Paid`} 
                                            </span>
                                            {parseInt(companyData.billing_status) === 2 && ( 
                                                <NavLink to={"/billing/pricing"} className="btn btn-sm btn-outline-dark ms-3 rounded-pill" 
                                                         data-toggle="tooltip" data-placement="right" title="Pay Now">
                                                    Pay Now
                                                </NavLink> 
                                            )} 
                                        </div>
                                    </div>
                                )} 

                                {companyData.auto_renew && ( 
                                    <div className="row mb-3 align-items-center">
                                        <div className="col-sm-4 billing-label">Auto Renew:</div>
                                        <div className="col-sm-8">
                                            <span className="billing-value me-2">{companyData.auto_renew}</span>
                                            
                                            {companyData.is_auto_renew === 1 && ( 
                                                <button type="button" className="billing-btn-outline" 
                                                        data-bs-toggle="modal" data-bs-target="#CancelRenewPlan" 
                                                        data-toggle="tooltip" data-placement="right" title="Change Auto Renew">
                                                    Change 
                                                </button> 
                                            )} 

                                            {companyData.plan_id > 0 && companyData.is_auto_renew === 0 && ( 
                                                <button type="button" className="billing-btn-outline" 
                                                        data-bs-toggle="modal" data-bs-target="#EnableRenewPlan" 
                                                        data-toggle="tooltip" data-placement="right" title="Change Auto Renew">
                                                    Change 
                                                </button> 
                                            )} 
        
                                            {companyData.is_auto_renew === 1 && ( 
                                                <CancelRenewPlan setLoading={setLoading} companyData={companyData} 
                                                                 setCompanyData={setCompanyData}/> 
                                            )} 

                                            {companyData.plan_id > 0 && companyData.is_auto_renew === 0 && ( 
                                                <EnableRenewPlan setLoading={setLoading} companyData={companyData} 
                                                                 setCompanyData={setCompanyData}/> 
                                            )} 
                                        </div>
                                    </div>
                                )} 

                                {companyData.next_renew_amount && ( 
                                    <div className="row mb-3">
                                        <div className="col-sm-4 billing-label">Next Renew Amount:</div>
                                        <div className="col-sm-8 billing-value fs-5">{companyData.next_renew_amount}</div>
                                    </div>
                                )} 

                                <hr className="text-muted opacity-25 my-4" />

                                <div className="row mb-4">
                                    <div className="col-sm-4 billing-label">Add on SMS Purchased:</div>
                                    <div className="col-sm-8 billing-value">{companyData.sms_purchased}</div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4 billing-label mb-2">Storage Used:</div>
                                    <div className="col-sm-8">
                                        <div className="d-flex justify-content-between mb-1">
                                            <span className="text-muted small">Usage</span>
                                            <span className="fw-bold text-dark small">{companyData.used_storage}</span>
                                        </div>
                                        <div className="progress" style={{height: '8px', borderRadius: '10px'}}> 
                                            <div className="progress-bar bg-primary" role="progressbar" 
                                                 style={{width: companyData.used_percentage + `%`, borderRadius: '10px'}} 
                                                 aria-valuenow={companyData.used_percentage + `%`} aria-valuemin="0" 
                                                 aria-valuemax="100"/> 
                                        </div> 
                                    </div>
                                </div>
                            </div> 
                        </div> 
                    </div>

                    {/* Right Column - Other Info */}
                    <div className="col-xl-5">

                        {/* Credit History - MOVED TO TOP */}
                        <div className="billing-card mb-4"> 
                            <div className="billing-card-header"> 
                                <h5 className="billing-card-title">Credit History</h5> 
                            </div> 
                            <div className="billing-card-body"> 
                                <div className="row g-3 mb-4"> 
                                    <div className="col-6">
                                        <div className="credit-box credit-box-blue"> 
                                            <div className="credit-label">
                                                {`Credits (${(companyData.plan_type_id) ? companyData.plan_type_id === 1 ? `Month` : `Year` : `Month`})`}
                                            </div>
                                            <div className="credit-value">
                                                {companyData.total_envelope_credit}
                                            </div>
                                            {companyData.total_sms > 0 && ( 
                                                <div className="small mt-1">
                                                    + {companyData.total_sms} SMS
                                                </div>
                                            )} 
                                        </div> 
                                    </div>
                                    
                                    <div className="col-6">
                                        <div className="credit-box credit-box-cyan"> 
                                            <div className="credit-label">
                                                Add-on SMS
                                            </div>
                                            <div className="credit-value">
                                                {companyData.addon_sms}
                                            </div>
                                            <div className="small mt-1">
                                                Remaining
                                            </div>
                                        </div> 
                                    </div>
                                </div> 
                                <div className="text-end">
                                    <NavLink to={"/billing/credit-history"} className="link-arrow" 
                                            data-toggle="tooltip" title="View History">
                                        View Transaction History <i className="bi bi-arrow-right"></i>
                                    </NavLink> 
                                </div>
                            </div> 
                        </div> 

                        {/* Billing History - MOVED BELOW CREDIT HISTORY */}
                        <div className="billing-card mb-4"> 
                            <div className="billing-card-header"> 
                                <h5 className="billing-card-title">Billing History</h5> 
                            </div> 
                            <div className="billing-card-body"> 
                                <p className="text-muted mb-3">View and download your past invoices and payment history.</p>
                                <div className="text-end">
                                    <NavLink to={"/billing/history"} className="link-arrow" 
                                            data-toggle="tooltip" title="View Invoices">
                                        Go to Billing History <i className="bi bi-arrow-right"></i>
                                    </NavLink> 
                                </div>
                            </div> 
                        </div> 
                        
                        {/* Payment Information */}
                        {companyData.card_type && ( 
                            <div className="billing-card mb-4"> 
                                <div className="billing-card-header d-flex justify-content-between align-items-center"> 
                                    <h5 className="billing-card-title">Payment Information</h5> 
                                    <div className="d-flex gap-2">
                                        <button type="button" className="btn btn-sm btn-outline-secondary rounded-pill px-3" 
                                                data-bs-toggle="modal" 
                                                data-bs-target="#PaymentCardEdit" data-toggle="tooltip" 
                                                title="Edit Card">Edit</button> 
                                        <button type="button" className="btn btn-sm btn-outline-danger rounded-pill px-3" 
                                                data-bs-toggle="modal" 
                                                data-bs-target="#removeCreditCard" data-toggle="tooltip" 
                                                title="Delete Card">Delete 
                                        </button> 
                                    </div>
                                </div> 
        
                                <PaymentCardEdit setLoading={setLoading} companyData={companyData} 
                                                 setCompanyData={setCompanyData}/> 
        
                                <div className="modal fade" id="removeCreditCard" tabIndex={-1} 
                                     aria-labelledby="removeCreditCardLabel" aria-hidden="true" data-bs-backdrop="static" 
                                     data-bs-keyboard="false"> 
                                    <div className="modal-dialog modal-dialog-centered"> 
                                        <div className="modal-content border-0 shadow"> 
                                            <div className="modal-header border-bottom-0 pb-0"> 
                                                <h5 className="modal-title fw-bold" id="removeCreditCardLabel"> 
                                                    Delete Card 
                                                </h5> 
                                                <button type="button" className="btn-close" 
                                                        ref={removeCreditCardRef} data-bs-dismiss="modal" aria-label="Close"> 
                                                </button> 
                                            </div> 
                                            <div className="modal-body py-4"> 
                                                <p className="mb-0 text-secondary">Are you sure you want to remove this card?</p> 
                                            </div> 
                                            <div className="modal-footer border-top-0 pt-0"> 
                                                <button type="button" className="btn btn-light rounded-pill px-4" 
                                                        data-bs-dismiss="modal">Cancel 
                                                </button> 
                                                <button type="button" onClick={handleDeleteCard} 
                                                        className="btn btn-danger rounded-pill px-4">Delete 
                                                </button> 
                                            </div> 
                                        </div> 
                                    </div> 
                                </div> 
        
                                <div className="billing-card-body"> 
                                    <div className="p-3 bg-light rounded-3">
                                        <div className="row mb-2">
                                            <div className="col-5 billing-label small">Payment Method:</div>
                                            <div className="col-7 billing-value">Credit Card</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 billing-label small">Card Type:</div>
                                            <div className="col-7 billing-value">{companyData.card_type}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 billing-label small">Card Number:</div>
                                            <div className="col-7 billing-value" style={{letterSpacing: '1px'}}>{companyData.card_number}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5 billing-label small">Card Holder:</div>
                                            <div className="col-7 billing-value">{companyData.card_holder_name}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-5 billing-label small">Expiry Date:</div>
                                            <div className="col-7 billing-value">{companyData.card_expired_date}</div>
                                        </div>
                                    </div>
                                </div> 
                            </div> 
                        )} 

                        {/* Billing Address */}
                        {companyData.address && ( 
                            <div className="billing-card mb-4"> 
                                <div className="billing-card-header"> 
                                    <h5 className="billing-card-title">Billing Address</h5> 
                                </div> 
                                <div className="billing-card-body pt-3"> 
                                    <div className="d-flex align-items-start">
                                        <i className="bi bi-geo-alt text-primary me-3 fs-5"></i>
                                        <p className="mb-0 text-dark fw-medium">{companyData.address}</p> 
                                    </div>
                                </div> 
                            </div> 
                        )} 

                    </div>
                </div>
            </div> 
        </> 
    ); 
} 
 
export default BillingOverview;
